import React from 'react'
import '../CEOSection/CEOSection.css'
import { FaCheck } from "react-icons/fa";

const CEOSection = () => {
  return (
    <div class="section harsafe-about-section-02 section-padding">
        <div class="container">
            {/* <!-- About Wrapper Start --> */}
            <div class="about-wrap">
                <div class="row">
                    <div class="col-lg-6">
                        {/* <!-- About Left Start --> */}
                        <div class="about-02-left text-center">
                            <div class="section-title">
                                <h2 class="title">Our mission is to empower lives through secure, innovative solutions, driving a seamless digital transformation for businesses and individuals.</h2>
                            </div>
                            <div class="about-author">
                                {/* <!-- <img src="assets/images/sign.png" alt=""> --> */}
                                <h3 class="name">Dharmendra Kumar Karigar</h3>
                                <span class="designation">CEO, Harsafe Technology Finance Service Pvt. Ltd.</span>
                            </div>
                        </div>
                        {/* <!-- About Left End --> */}
                    </div>
                    <div class="col-lg-6">
                        {/* <!-- About Right Start --> */}
                        <div class="about-02-right">
                            <p>We are committed to delivering innovative, secure, and user-friendly solutions that redefine possibilities, enhance efficiency, and empower businesses and individuals to thrive in an increasingly connected digital world.</p>
                            <div class="about-list">
                                <ul>
                                    <li>
                                        <span class="about-icon"><FaCheck /></span>
                                        <span class="about-text">Driving Creative Solutions for Growth.</span>
                                    </li>
                                    <li>
                                        <span class="about-icon"><FaCheck /></span>
                                        <span class="about-text">Ensuring Trust with Robust Protection.</span>
                                    </li>
                                    <li>
                                        <span class="about-icon"><FaCheck /></span>
                                        <span class="about-text">Delivering Quality Beyond Expectations.</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        {/* <!-- About Right End --> */}
                    </div>
                </div>
            </div>
            {/* <!-- About Wrapper End --> */}
        </div>
    </div>
  )
}

export default CEOSection